export default __webpack_public_path__ + "static/media/credit-clock.c2b72fce.svg";